<template>
  <div>
    <v-card outlined elevation="0" class="rounded-lg ma-4" tile>
      <v-sheet :class="showLoisirs ? '' : 'rounded-lg'" color="primary">
        <v-card-title class="py-2 card-title-height">
          <v-btn icon @click="card()">
            <v-icon color="white">
              {{
                showLoisirs ? "mdi-chevron-up" : "mdi-chevron-down"
              }}
            </v-icon>
          </v-btn>
          <span class="text-body-1 white--text pr-4">Commandes Loisirs</span>
          <v-select
            v-if="showLoisirs"
            v-model="statusFilter"
            class="col-2"
            placeholder="Statut"
            :items="['All', 'Paid', 'Not Paid']"
            hide-details
            dense
            solo
            flat
          />
          <v-spacer />
          <v-btn elevation="0" icon @click="getCustomerOrderDetails()">
            <v-icon color="white" class="pr-1">mdi-refresh</v-icon>
          </v-btn>
        </v-card-title>
      </v-sheet>
      <v-expand-transition>
        <div v-show="showLoisirs" class="grey lighten-4">
          <v-divider />
          <div class="">
            <v-data-table
              :headers="headers.filter(h => !h.hidden)"
              fixed-header
              height="300"
              :items="tableItems"
              :server-items-length="search.results.count"
              :loading="search.loading"
              :options.sync="options"
              loading-text="Loading... Please wait"
              class="elevation-1"
              @update:page="searchOrders()"
              @update:items-per-page="searchOrders()"
            >
              <template #item.qrcode="{ item }">
                {{ (item.order.order_items.reduce((prev, curr) => curr.qrcode && curr.qrcode.length ? [...prev, ...curr.qrcode] : prev, []) || []).join(', ') }}
              </template>
              <template #item.orderStock="{ item }">
                <div v-if="orderStock(item) !== null" class="d-flex">
                  <span>{{ orderStock(item) }}</span>
                  <v-icon class="ml-1" size="large" @click="openModal(item)">mdi-pencil</v-icon>
                </div>
              </template>
              <template #item.isPaid="{ item }">
                <a v-if="item.order.orderUrl" :href="item.order.orderUrl" class="link-btn" target="_blank">
                  <span>
                    {{ item.paymentStatus || (item.isPaid ? 'Paid' : 'Not paid') }}
                  </span>
                </a>
                <span v-else>
                  {{ item.paymentStatus || (item.isPaid ? 'Paid' : 'Not paid') }}
                </span>
              </template>

              <template #item.contremarque="{ item }">
                <v-switch
                  :input-value="contremarque(item)"
                  @change="(e) => changeOrder('contremarque', item, e)"
                />
              </template>

              <template #item.sans_support="{ item }">
                <v-switch
                  :input-value="sans_support(item)"
                  @change="(e) => changeOrder('sans_support', item, e)"
                />
              </template>

              <template #item.principalProduct="{ item }">
                {{ principalProduct(item) }}
              </template>

              <template #item.totalPrice="{ item }">
                {{ isGymlibOrder(item) ? '-' : `${totalPrice(item)} €` }}
              </template>

              <template #item.isBuyer="{ item }">
                {{ item.buyer.uuid === $route.params.uuid ? 'Oui' : 'Non' }}
              </template>

              <template #item.holder="{ item }">
                <template v-if="item.holder && item.holder.length">
                  <div v-for="(contact, index) in item.holder" :key="`holder_${index}`">
                    <template v-if="contact">
                      <span>{{ contact.firstname }} {{ contact.lastname }}</span>
                      <a :href="`/customer/${contact.uuid}`" target="_blank"><v-icon>mdi-open-in-new</v-icon></a>
                    </template>
                    <span v-else>NA</span>
                  </div>
                </template>
                <span v-else>NA</span>
              </template>
              <template #item.sync="{ item }">
                <v-btn v-if="canShowSyncButton(item)" icon @click="syncHoranetOrders(item)"><v-icon>mdi-sync</v-icon></v-btn>
              </template>
              <template #item.blocked="{ item }">
                <v-switch
                  v-if="item.showBlocked"
                  v-model="item.blocked"
                  @change="showChangeOrderStatus(item)"
                />
              </template>
              <template #item.codesGymlib="{ item }">
                {{ item.order.order_items.reduce((acc, prev) => acc ? acc.join(prev.gymlibCode || '', ' ,') : prev.gymlibCode || '' , '') }}
              </template>
              <template #item.validityEnd="{ item }">
                <div v-if="orderValidityEnd(item)">
                  {{ orderValidityEnd(item) }}
                  <v-icon v-if="canShowEditContractDate" class="ml-1" size="large" @click="openModalValidityEnd(item)">mdi-pencil</v-icon>
                </div>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-expand-transition>
    </v-card>

    <!-- MODAL -->
    <AlphaOrderStatusModal :order="selectedOrder" />
    <UpdateStockModal :order="selectedOrder" :customer="customer" :fetched-orders="search.results.items || []" />
    <AlphaOrderContractDateModal :order="selectedOrder" :customer="customer" />
  </div>
</template>

<script>

import { requests } from '@/mixins';
import { nextTick } from 'vue';
import { EventBus } from '../../mixins';
import { format, isValid } from 'date-fns';

import UpdateStockModal from '@/components/order/UpdateStockModal.vue';
import AlphaOrderStatusModal from '@/components/profile/AlphaOrderStatusModal';
import AlphaOrderContractDateModal from '@/components/order/AlphaOrderContractDateModal';

export default {
  components: { AlphaOrderStatusModal, UpdateStockModal, AlphaOrderContractDateModal },
  mixins: [requests],
  props: { customer: Object },
  data () {
    return {
      search: {
        abortController: null,
        loading: false,
        results: {}
      },
      ordersSynced: [],
      ordersStatus: [],
      change: { abortController: null },
      options: { itemsPerPage: 5 },
      showLoisirs: true,
      statusFilter: 'All',
      selectedOrder: null,
      stockModalOpen: false
    };
  },
  computed: {
    headers () {
      return [
        { text: 'Nº Commande', value: 'uuid', sortable: false },
        { text: 'Centre', value: 'site_workspace', sortable: false },
        { text: 'Produit principal', value: 'principalProduct', sortable: false },
        { text: 'Total', value: 'totalPrice', sortable: false },
        { text: 'Statut', value: 'isPaid', sortable: false },
        { text: 'Codes EGYM Wellpass', value: 'codesGymlib', sortable: false },
        { text: 'Crédit', value: 'orderStock', sortable: false, hidden: !this.tableItems.some(item => item.order.isInternalSession) },
        { text: 'Date', value: 'date', sortable: false },
        { text: 'Date d\'expiration', value: 'validityEnd', width: '150', align: 'center', sortable: false, hidden: !this.tableItems.some(item => item.order.isInternalSession)},
        { text: 'Payeur', value: 'isBuyer', sortable: false },
        { text: 'Titulaire', value: 'holder', sortable: false },
        { text: 'N° Support', value: 'qrcode', sortable: false },
        { text: 'Contremarque', value: 'contremarque', sortable: false },
        { text: 'Sans Support', value: 'sans_support', sortable: false },
        { text: 'Rejouer boucle', value: 'sync', sortable: false, hidden: !this.$store.state.user.roles.includes('admin') },
        { text: 'Blocage support', value: 'blocked', sortable: false, hidden: !this.$store.state.user.roles.some(role => ['admin', 'alpha_contract_management'].includes(role)) }
      ];
    },
    tableItems () {
      if (this.search.results && this.search.results.items) {
        return this.search.results.items.map(order => {
          const orderStatus = this.ordersStatus.find(o => o.uuid === order.uuid);

          return {
            ...order,
            blocked: orderStatus ? orderStatus.blocked : null,
            showBlocked: !!orderStatus,
            isBlocked: orderStatus ? orderStatus.blocked : null,
            holder: order && order.order && order.order.order_items ? order.order.order_items.map(o => (o && o.customer) || null) : null
          };
        });
      }
      return [];
    },
    canShowEditContractDate () {
      return (this.$store.state.user.roles || []).some(role => ['admin', 'alpha_contract_end_date_update'].includes(role))
    }
  },
  watch: {
    statusFilter () {
      this.searchOrders();
    }
  },
  async mounted () {
    EventBus.$on('handle-order-alpha-status', ({ advance }) => this.manageOrderStatus(advance));
    EventBus.$on('update-stock', ({ contractNumber, newStock, remainingStockMinusReservations }) => this.updateStock(contractNumber, newStock, remainingStockMinusReservations));
    EventBus.$on('update-contract-validity', ({ contractNumber, validityEnd }) => this.updateContractValidity(contractNumber, validityEnd));
  },
  created () {
    this.searchOrders();
  },
  methods: {
    openModalValidityEnd (item) {
      this.selectedOrder = item;
      EventBus.$emit('show-alpha-order-contract-date-modal');
    },
    orderValidityEnd (order) {
      const customerOrderItem = order.order.order_items.find(oi => oi.customer && oi.customer.uuid === this.customer.uuid);
      if(!customerOrderItem || !customerOrderItem.contract || !customerOrderItem.contract.validityEnd) return null;

      const validityEnd = new Date(customerOrderItem.contract.validityEnd.split('T')[0]);

      if(!isValid(validityEnd)) return null;

      return format(validityEnd, 'dd/MM/yyyy');
    },
    orderStock (order) {
      const customerOrderItem = order.order.order_items.find(oi => oi.customer && oi.customer.uuid === this.customer.uuid && oi.reloadable);
      return customerOrderItem && customerOrderItem.contract ? customerOrderItem.contract.remainingStock : null;
    },
    async manageOrderStatus (advance) {
      const index = this.search.results.items.findIndex(i => i.uuid === this.selectedOrder.uuid);
      if (!advance) {
        this.selectedOrder.blocked = !this.selectedOrder.blocked;
        if (index !== -1) {
          this.search.results.items[index].blocked = !this.selectedOrder.blocked;
        }
        return;
      }
      // aqui chamar api para bloquear/desbloquear
      const notification = {
        message: 'Erreur de blocage/déblocage du contrat',
        type: 'danger'
      };
      const response = await this.changeOrderStatus(this.selectedOrder.uuid, this.selectedOrder.blocked);

      let status = !this.selectedOrder.blocked;

      if (response.success) {
        notification.message = 'Succès bloquer/débloquer le contrat';
        notification.type = 'success';

        status = this.selectedOrder.blocked;
      }

      if (index !== -1) {
        this.search.results.items[index].blocked = status;
      }

      EventBus.$emit('show-notifications', [notification]);
    },
    showChangeOrderStatus (item) {
      this.selectedOrder = item;
      // show confirmation modal

      EventBus.$emit('show-alpha-order-status-modal');
    },
    async getCustomerOrderDetails () {
      let workspaces = [];
      if (this.search.results && this.search.results.items) {
        workspaces = this.search.results.items.map(item => item.siteWorkspaceCode);
      }
      const notification = {
        message: 'Obtenir le statut de la commande',
        type: 'info',
        timeout: 16000
      };
      EventBus.$emit('show-notifications', [notification]);

      const response = await this.getCustomerAlphaOrderStatus(this.$props.customer.uuid, [...new Set(workspaces)].join(','));

      if (!response || (response && !response.success)) {
        EventBus.$emit('show-notifications', [{
          message: response.message || 'Erreur lors de l\'obtention du statut de la commande',
          type: 'error'
        }]);
        return;
      }

      this.ordersStatus = response.data;
      EventBus.$emit('show-notifications', [{
        message: 'Les contrats de commandes sont récupérés avec succès',
        type: 'success'
      }]);
    },
    canShowSyncButton (item) {
      return item && item.order_status && item.order_status.status && item.order_status.status === 'horanet_failed' && !this.ordersSynced.includes(item.uuid);
    },
    async syncHoranetOrders (item) {
      this.search.loading = true;
      this.ordersSynced.push(item.uuid);
      const response = await this.getAlphaOrderPaymentsToSync(item.uuid);

      const payments = (response.data || []).map(payment => ({
        ...payment,
        status: 'loading'
      }));

      this.$store.commit('setAlphaPaymentToSync', payments);
      EventBus.$emit('change-payment-notification-status');

      let storePayments = [...this.$store.state.alphaPaymentsToSync];

      // call sync horanet callback one by one
      for (const payment of payments) {
        EventBus.$emit('change-payment-label', payment.payment_intent);
        const responseSync = await this.syncAlphaOrderWithHoranet(payment.uuid, payment.payment_intent);

        if (payment.type === 'paymentCallback' && (!responseSync || (responseSync && !responseSync.success))) {
          storePayments = storePayments.map(p => ({ ...p, status: 'error' }));
          break;
        }

        const index = storePayments.findIndex(p => p.payment_intent === payment.payment_intent);

        if (index !== -1) {
          storePayments[index].status = responseSync && responseSync.success ? 'success' : 'error';
          this.$store.commit('setAlphaPaymentToSync', storePayments);
        }
      }

      setTimeout(() => {
        EventBus.$emit('change-payment-notification-status');

        const syncedWithSuccess = storePayments.filter(p => p.status === 'success');
        const syncedWithError = Math.round(storePayments.length - syncedWithSuccess.length);
        const message = `${syncedWithSuccess.length} sur ${storePayments.length} synchronisés avec succès\n${syncedWithError} sur ${storePayments.length} synchronisés sans succès`;

        const notification = {
          message: message,
          type: 'success',
          timeout: 6000
        };

        EventBus.$emit('show-notifications', [notification]);
      }, 3000);

      this.search.loading = false;
    },
    card () {
      this.showLoisirs = !this.showLoisirs;
    },
    totalPrice (genericOrder) {
      return (genericOrder.order.total / 100).toFixed(2);
    },
    principalProduct (genericOrder) {
      const order_item = genericOrder.order.order_items[0];
      return `${order_item.product_name} - ${order_item.horanet_product_name}`;
    },
    contremarque (genericOrder) {
      const contremarque = genericOrder.order.order_items.some(i => i.contremarque);
      return contremarque;
    },
    sans_support (genericOrder) {
      const sans_support = genericOrder.order.order_items.some(i => i.sans_support);
      return sans_support;
    },
    isGymlibOrder (genericOrder) {
      return genericOrder.order.gymlibOrderUuid;
    },
    async searchOrders () {
      const { page } = this.options;
      const itemsPerPage = this.options.itemsPerPage === -1 ? this.search.results.count : this.options.itemsPerPage;
      this.search.loading = true;

      if (this.search.abortController) {
        this.search.abortController.abort();
      }

      this.search.abortController = new AbortController();

      const start = (page - 1) * itemsPerPage || 0;
      const limit = itemsPerPage;
      const costumerId = this.customer.uuid;
      const responseOrders = await this.getOrders(start, limit, costumerId, 'alpha', this.statusFilter);

      if (responseOrders.success) {
        this.search.results = responseOrders.data;
      }
      this.search.loading = false;
    },
    async changeOrder (field, item, value) {
      this.search.loading = true;

      if (this.change.abortController) {
        this.change.abortController.abort();
      }

      this.change.abortController = new AbortController();
      const data = {};
      data[field] = value;
      await this.updateOrder({
        order_uuid: item.uuid,
        data: data
      });

      this.search.loading = false;
    },
    openModal (item) {
      this.selectedOrder = item;
      nextTick(() => {
        EventBus.$emit('show-stock-update-modal');
      });
    },
    updateStock (contractNumber, newStock, remainingStockMinusReservations) {
      const updatedItems = JSON.parse(JSON.stringify(this.search.results.items));

      updatedItems.forEach(order => {
        order.order.order_items.forEach(item => {
          if (item.contract && item.contract.contractNumber === contractNumber) {
            item.contract.remainingStock = newStock;
            item.contract.remainingStockMinusReservations = remainingStockMinusReservations;
            this.selectedOrder = order;
          }
        });
      });

      this.search.results.items = updatedItems;
    },
    updateContractValidity (contractNumber, newEndDate) {
      const updatedItems = JSON.parse(JSON.stringify(this.search.results.items));
      updatedItems.forEach(order => {
        order.order.order_items.forEach(item => {
          if (item.contract && item.contract.contractNumber === contractNumber) {
            item.contract.validityEnd = newEndDate;
            this.selectedOrder = order;
          }
        });
      });
      this.search.results.items = updatedItems;
    }
  }
};
</script>

<style scoped>
  .link-btn{
    text-decoration: none;
    color: blue;
    cursor: pointer;
  }
</style>
